export function SkeletonCard() {
  return (
    <div className="border-2 border-ink/15 bg-white overflow-hidden" data-testid="skeleton-card">
      <div className="skeleton aspect-[16/10] border-b-2 border-ink/10" />
      <div className="p-4 space-y-3">
        <div className="skeleton h-5 w-4/5" />
        <div className="skeleton h-3 w-full" />
        <div className="skeleton h-3 w-2/3" />
        <div className="skeleton h-7 w-1/2 mt-2" />
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 8 }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );
}
